module.exports = __webpack_public_path__ + "static/media/list-svgrepo-com.a5939197.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/list-svgrepo-com.svg
// module id = 954
// module chunks = 0